import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { hideLoader, showLoader } from "./loaderSlice";
import { showToast } from "./toastSlice";
// import { getMyProfileAction ,getMyRole} from "./userSlice";

const initialState = {
  data: [],
  list: [],
  details: {},
};

export const createSsoAction = createAsyncThunk(
  "sso/create",
  async ({ data, navigate }, { dispatch }) => {
    try {
      dispatch(showLoader());

      const res = await api("post", Constants.END_POINT.sso, data);
      if (res?.success && res?.data) {
        dispatch(
          showToast({
            severity: "success",
            summary: res?.message || res?.data?.message,
          })
        );
        navigate("/sso/list");
        return Promise.resolve(res?.data);
      } else {
        dispatch(
          showToast({
            severity: "error",
            summary: res?.data?.message || res?.message,
          })
        );
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const getSsoList = createAsyncThunk(
  "sso/get",
  async ({ id, next }, { dispatch }) => {
    try {
      const res = await api("get", Constants.END_POINT.sso + `?id=${id}`, {});
      if (res?.success && res?.data) {
        dispatch(setSsoList(res?.data));
        return Promise.resolve(res?.data);
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
    }
  }
);

export const getSingleSso = createAsyncThunk(
  "sso/get",
  async ({ id, next }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "get",
        Constants.END_POINT.sso_single + `?id=${id}`,
        {}
      );
      if (res?.success && res?.data) {
        next(res?.data);
        dispatch(setSsoSingle(res?.data));
        return Promise.resolve(res?.data);
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const updateSsoAction = createAsyncThunk(
  "sso/get",
  async ({ id, data, navigate }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "post",
        Constants.END_POINT.sso_update + `?id=${id}`,
        data
      );
      if (res?.success && res?.data) {
        dispatch(
          showToast({
            severity: "success",
            summary: res?.data?.message || res?.message,
          })
        );
        navigate("/sso/list");
        return Promise.resolve(res?.data);
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const deleteSsoAction = createAsyncThunk(
  "sso/get",
  async ({ id, activeOrg }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "delete",
        Constants.END_POINT.sso + `?id=${id}`,
        {}
      );
      if (res?.success) {
        dispatch(
          showToast({
            severity: "success",
            summary: res?.data?.message || res?.message,
          })
        );
        dispatch(getSsoList({ id: activeOrg?.id }));
        return Promise.resolve(res?.data);
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.resolve(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

const ssoSlice = createSlice({
  name: "sso",
  initialState,
  reducers: {
    setSsoDetail: (state, action) => {
      state.data = action.payload;
    },
    setSsoList: (state, action) => {
      state.list = action.payload;
    },
    setSsoSingle: (state, action) => {
      state.details = action.payload;
    },
  },
});

export const { setSsoDetail, setSsoList, setSsoSingle } = ssoSlice.actions;

export default ssoSlice.reducer;
